/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, Input, ModalComp } from "../../../components";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreatePromotionalNotification,
  DeletePromotionalNotification,
  GetPromotionalNotification,
  UpdatePromotionalNotification,
} from "../../../utilities/api/promotional-notification";
import { nameValidation2, nameWithNumberValidation } from "../../../utilities/utils";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { Days } from "../../../utilities/utils";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.notification;

const errorInit = {
  templateName: "",
  title: "",
  message: "",
  startDate: "",
  endDate: "",
  sendToUsers: "",

  sendOnDays: "",
};

const CreateUpdatePromotionalNotification = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState({
    templateName: "",
    title: "",
    message: "",
    startDate: "",
    endDate: "",
    sendToUsers: [],
    sendOnTime: "",
    sendOnDays: [],
  }) as any;
  const [error, setError] = useState({ ...errorInit });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const ALL_COLUMNS = [
    {
      value: "Corporate Booking Customers",
      labelKey: "corporateBookingUsers",
    },
    {
      value: "Associate Booking Customers",
      labelKey: "associateBookingUsers",
    },
    {
      value: "Individual Booking Customers",
      labelKey: "individualBookingUsers",
    },
    {
      value: "Session Booking Customers",
      labelKey: "sessionBookingUsers",
    },
    {
      value: "Selling Booking Customers",
      labelKey: "sellingOrderUsers",
    },

    {
      value: "Renting Booking Customers",
      labelKey: "rentingOrderUsers",
    },
  ];
  const Events = [
    {
      value: "Everyday 9 AM",
      labelKey: "all",
    },
    {
      value: "Select days for 9 Am",
      labelKey: "",
    },
  ];

  const getNotificationDetail = async () => {
    const result = await GetPromotionalNotification(`${id || ""}`);
    const _data = result?.data;
    setData({
      templateName: _data?.templateName,
      title: _data?.title,
      message: _data?.message,
      startDate: _data?.startDate,
      endDate: _data?.endDate,
      sendToUsers: _data?.sendToUsers,
      sendOnTime: _data?.sendOnDays?.length < 7 ? "" : "all",
      sendOnDays: _data?.sendOnDays,
    });
  };

  useEffect(() => {
    if (id) {
      getNotificationDetail();
    }
  }, []);

  const updateData = (key: any, value: any = "") => {
    setError({ ...errorInit });
    if (typeof key === "object") {
      setData((oldSession: any) => ({ ...oldSession, ...key }));
    } else {
      setData((oldSession: any) => ({ ...oldSession, [key]: value }));
    }
  };

  const isValid = () => {
    if (
      !data?.templateName ||
      nameValidation2(data?.templateName) == null ||
      data?.templateName.length > 30 ||
      !data?.title ||
      nameValidation2(data?.title) == null ||
      data?.title.length > 100 ||
      !data?.message ||
      data?.message.length > 300 ||
      !data?.startDate ||
      !data?.endDate ||
      !data?.sendToUsers?.length ||
      !data?.sendOnDays?.length
    ) {
      setError({
        templateName: data?.templateName
          ? nameValidation2(data?.templateName) == null
            ? getMessage.templateName_matches
            : data?.templateName.length > 30
              ? getMessage.templateName_maxLength
              : ""
          : getMessage.templateName_required,
        title: data?.title
          ? nameValidation2(data?.title) == null
            ? getMessage.title_matches
            : data?.title.length > 100
              ? getMessage.title_maxLength
              : ""
          : getMessage.title_required,
        message: data?.message
          ? data?.message.length > 300
            ? getMessage.message_maxLength
            : ""
          : getMessage.message_required,
        startDate: data?.startDate ? "" : getMessage.startDate_required,
        endDate: data?.endDate ? "" : getMessage.endDate_required,
        sendToUsers: data?.sendToUsers?.length ? "" : getMessage.sendToUsers_required,
        sendOnDays: data?.sendOnDays?.length ? "" : getMessage.sendOnDays_required,
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (isValid()) {
      let payload = {
        ...data,
        sendToUsers:
          data?.sendToUsers?.indexOf?.("allUsers") > -1
            ? ALL_COLUMNS?.map?.(_column => _column?.labelKey)?.filter?.(key => key !== "allUsers")
            : data?.sendToUsers,
        sendOnTime: "09:00",
        startDate: data?.startDate && format(getFormatedDate(data?.startDate), "yyyy-MM-dd"),
        endDate: data?.endDate && format(getFormatedDate(data?.endDate), "yyyy-MM-dd"),
      };
      let result;
      if (id) {
        result = await UpdatePromotionalNotification(id, payload);
      } else {
        result = await CreatePromotionalNotification(payload);
      }
      if (result?.status === 200) {
        toast.success(result?.data?.message);
        navigate("/promotional-notification");
      } else {
        toast.error(result.response.data.message);
      }
    }
  };

  const handleDelete = async () => {
    if (id) {
      const result = await DeletePromotionalNotification(id);
      if (result?.status === 200) {
        toast.success(result?.data?.message);
        setShowDeleteModal(false);
        navigate("/promotional-notification");
      } else {
        toast.error(result.response.data.message);
      }
    }
  };

  const getFormatedDate = (_date: string) => {
    if (typeof _date !== "string") {
      return _date;
    }
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="text-start mb-0">
                {id ? "Update" : "Create"} Promotional Notification
              </Card.Title>
              {!!id && (
                <Button
                  type="button"
                  bname="Delete Notification"
                  name="delete-notification"
                  id="delete-notification"
                  className="btn btn-danger rounded-1 "
                  onClick={() => setShowDeleteModal(true)}
                ></Button>
              )}
            </div>
            <hr />
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="notification" className="form-label">
                    Notification Name <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    className="form-control"
                    name="notification"
                    id="notification"
                    value={data?.templateName}
                    onChange={(e: any) => updateData("templateName", e.target.value)}
                  />
                  {error?.templateName && <div className="error-msg">{error?.templateName}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="notification" className="form-label">
                    Notification Title <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    className="form-control"
                    name="notification"
                    id="notification"
                    value={data?.title}
                    onChange={(e: any) => updateData("title", e.target.value)}
                  />
                  {error?.title && <div className="error-msg">{error?.title}</div>}
                </div>
              </Col>
              {!id ? (
                <>
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="startDate" className="form-label">
                        From Date <small className="text-danger">*</small>
                      </label>
                      <DatePicker
                        id="startDate"
                        inputClass="form-control"
                        format="DD/MM/YYYY"
                        containerClassName="custom-container"
                        onChange={(date: any) =>
                          updateData("startDate", date?.toDate().toUTCString())
                        }
                        editable={false}
                        value={data?.startDate ? getFormatedDate(data?.startDate) : ""}
                        render={<InputIcon className="form-control" />}
                        maxDate={new Date(data?.endDate)}
                        minDate={new Date()}
                      />
                      {error?.startDate && <div className="error-msg">{error?.startDate}</div>}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="endDate" className="form-label">
                        To Date <small className="text-danger">*</small>
                      </label>
                      <DatePicker
                        id="endDate"
                        inputClass="form-control"
                        format="DD/MM/YYYY"
                        containerClassName="custom-container"
                        onChange={(date: any) =>
                          updateData("endDate", date?.toDate().toUTCString())
                        }
                        editable={false}
                        value={data?.endDate ? getFormatedDate(data?.endDate) : ""}
                        render={<InputIcon className="form-control" />}
                        minDate={new Date(data?.startDate)}
                      />
                      {error?.endDate && <div className="error-msg">{error?.endDate}</div>}
                    </div>
                  </Col>
                </>
              ) : (
                <Row>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <div className="fw-semibold mb-3">
                        Start Date:{" "}
                        <span className="text-info">
                          {id ? `${data?.startDate}` : "Create"}
                        </span>{" "}
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3 text-start">
                      <div className="fw-semibold mb-3">
                        End Date:{" "}
                        <span className="text-info">{id ? `${data?.endDate}` : "Create"}</span>{" "}
                      </div>
                    </div>
                  </Col>
                </Row>
              )}

              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label htmlFor="todate" className="form-label">
                    Message <small className="text-danger">*</small>
                  </label>
                  <textarea
                    className="form-control"
                    name="cmsg"
                    id="cmsg"
                    value={data?.message}
                    onChange={e => updateData("message", e.target.value)}
                  ></textarea>
                  {error?.message && <div className="error-msg">{error?.message}</div>}
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="sendto" className="form-label">
                    Send To <small className="text-danger">*</small>
                  </label>
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={ALL_COLUMNS}
                    isMultiSelect={true}
                    showTick={true}
                    showAction={true}
                    placeholder="Send to"
                    defaultOptions={data?.sendToUsers}
                    onChange={e => {
                      let _val = e.selectedKey;
                      if (data?.sendToUsers?.indexOf("allUsers") > -1 && _val?.length > 1) {
                        _val = _val?.filter?.((_opt: string) => _opt !== "allUsers");
                      } else if (data?.sendToUsers?.length && _val?.indexOf("allUsers") > -1) {
                        _val = ["allUsers"];
                      }
                      updateData("sendToUsers", _val);
                    }}
                  />
                  {error?.sendToUsers && <div className="error-msg">{error?.sendToUsers}</div>}
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="event" className="form-label">
                    Events To Send <small className="text-danger">*</small>
                  </label>
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={Events}
                    isMultiSelect={false}
                    showTick={false}
                    showAction={false}
                    placeholder=""
                    defaultOptions={[data?.sendOnTime]}
                    onChange={(e) => {
                      const _val = e.selectedKey[0];
                      let _sendOnDays = data?.sendOnDays;
                      if (_val === "all") {
                        _sendOnDays = [
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                          "Sunday",
                        ];
                      } else {
                        _sendOnDays = [];
                      }
                      updateData({ sendOnTime: _val, sendOnDays: _sendOnDays });
                    }}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="event" className="form-label">
                    Select Day <small className="text-danger">*</small>
                  </label>
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={Days}
                    isMultiSelect={true}
                    showTick={true}
                    showAction={true}
                    placeholder="Days"
                    defaultOptions={data?.sendOnDays}
                    onChange={e => updateData("sendOnDays", e.selectedKey)}
                    disabled={data?.sendOnTime === "all"}
                  />
                  {error?.sendOnDays && <div className="error-msg">{error?.sendOnDays}</div>}
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={12} className="text-end mt-3">
                <Button
                  type="button"
                  bname="Submit"
                  name="send-notification"
                  id="send-notification"
                  className="btn btn-primary rounded-1"
                  onClick={() => handleSubmit()}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <ModalComp
        archive={showDeleteModal}
        setArchive={setShowDeleteModal}
        handleDelete={handleDelete}
        message=""
      />
    </>
  );
};
export { CreateUpdatePromotionalNotification };
